export default __webpack_public_path__ + "static/media/Cash_Free_Payment_Prev.6b8b7601.png";